"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const schedulo_1 = require("schedulo");
const dymo_core_1 = require("dymo-core");
const scheduler_1 = require("./scheduler");
//list of used features to speed up init
const FEATURES = [dymo_core_1.uris.TIME_FEATURE, dymo_core_1.uris.DURATION_FEATURE];
const PAIRINGS = new Map();
PAIRINGS.set(dymo_core_1.uris.TIME_FEATURE, schedulo_1.Parameter.Offset);
PAIRINGS.set(dymo_core_1.uris.DURATION_FEATURE, schedulo_1.Parameter.Duration);
PAIRINGS.set(dymo_core_1.uris.ONSET, schedulo_1.Parameter.StartTime);
PAIRINGS.set(dymo_core_1.uris.DURATION, schedulo_1.Parameter.Duration);
PAIRINGS.set(dymo_core_1.uris.DURATION_RATIO, schedulo_1.Parameter.DurationRatio);
PAIRINGS.set(dymo_core_1.uris.AMPLITUDE, schedulo_1.Parameter.Amplitude);
PAIRINGS.set(dymo_core_1.uris.PAN, schedulo_1.Parameter.Panning);
PAIRINGS.set(dymo_core_1.uris.DISTANCE, schedulo_1.Parameter.Panning);
PAIRINGS.set(dymo_core_1.uris.HEIGHT, schedulo_1.Parameter.Panning);
PAIRINGS.set(dymo_core_1.uris.REVERB, schedulo_1.Parameter.Reverb);
PAIRINGS.set(dymo_core_1.uris.DELAY, schedulo_1.Parameter.Delay);
//PAIRINGS.set(uris.LOOP, Parameter.Loop);
PAIRINGS.set(dymo_core_1.uris.PLAYBACK_RATE, schedulo_1.Parameter.PlaybackRate);
PAIRINGS.set(dymo_core_1.uris.TIME_STRETCH_RATIO, schedulo_1.Parameter.TimeStretchRatio);
class ScheduloScheduledObject extends scheduler_1.ScheduledObject {
    constructor(dymoUri, previousObject, player) {
        super(dymoUri, player);
        this.previousObject = previousObject;
        this.typeToBehavior = new Map();
        this.dymoToParam = new Map();
        this.attributeToType = new Map();
        this.attributeToValue = new Map();
        this.attributeToValueAfterBehavior = new Map();
        this.observedParams = [];
        this.init2();
    }
    init2() {
        return __awaiter(this, void 0, void 0, function* () {
            this.ready = Promise.all([...PAIRINGS.keys()].map((typeUri) => __awaiter(this, void 0, void 0, function* () {
                yield this.initAttribute(this.dymoUri, typeUri);
                //if behavior not independent, init parent attributes
                let behavior = yield this.store.findObject(typeUri, dymo_core_1.uris.HAS_BEHAVIOR);
                this.typeToBehavior.set(typeUri, behavior);
                if (behavior && behavior !== dymo_core_1.uris.INDEPENDENT) {
                    yield Promise.all(this.parentUris.map(p => this.initAttribute(p, typeUri)));
                }
                this.updateObjectParam(typeUri);
            })));
        });
    }
    initAttribute(dymoUri, typeUri) {
        return __awaiter(this, void 0, void 0, function* () {
            let attributeUri;
            if (FEATURES.indexOf(typeUri) >= 0) {
                attributeUri = yield this.store.setFeature(dymoUri, typeUri);
            }
            else {
                attributeUri = yield this.store.addParameterObserver(dymoUri, typeUri, this);
                this.observedParams.push([dymoUri, typeUri]);
            }
            let value = yield this.store.findAttributeValue(dymoUri, typeUri);
            this.dymoToParam.set(dymoUri, attributeUri);
            this.attributeToType.set(attributeUri, typeUri);
            //if (value != null) {
            this.attributeToValue.set(attributeUri, value);
            //}
        });
    }
    getSourcePath() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.store.getSourcePath(this.dymoUri);
        });
    }
    isEvent() {
        return __awaiter(this, void 0, void 0, function* () {
            const type = yield this.store.findObject(this.dymoUri, dymo_core_1.uris.CDT);
            return type === dymo_core_1.uris.EVENT;
        });
    }
    getTriggerFunction() {
        return __awaiter(this, void 0, void 0, function* () {
            const target = yield this.store.findObject(this.dymoUri, dymo_core_1.uris.HAS_TARGET);
            const value = yield this.store.findObjectValue(this.dymoUri, dymo_core_1.uris.VALUE);
            return () => this.store.setValue(target, dymo_core_1.uris.VALUE, value);
        });
    }
    setScheduloObject(object) {
        this.object = object;
        this.object.on('playing', () => this.player.objectStarted(this));
        this.object.on('stopped', this.stopped.bind(this));
        this.attributeToValueAfterBehavior.forEach((value, typeUri) => this.setObjectParam(typeUri, value));
    }
    getScheduloObject() {
        return this.object;
    }
    getDuration() {
        return this.object.getDuration();
    }
    getParam(paramUri) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.ready;
            return this.attributeToValueAfterBehavior.get(paramUri);
        });
    }
    //done playing naturally (schedulo)
    stopped() {
        return __awaiter(this, void 0, void 0, function* () {
            this.player.objectEnded(this);
            yield this.removeFromObservers();
        });
    }
    //stopped from above (dymo player)
    stop() {
        if (this.object) {
            this.object.stop(schedulo_1.Time.Asap, schedulo_1.Stop.Asap);
        }
        return this.removeFromObservers();
    }
    removeFromObservers() {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.all(this.observedParams.map(([dymoUri, typeUri]) => this.store.removeParameterObserver(dymoUri, typeUri, this)));
        });
    }
    updateObjectParam(typeUri) {
        //console.log("UPDATE", typeUri)
        //TODO GO THROUGH ALL PARENTS AND PROCESS (* or +...)
        let paramsOfType = [...this.attributeToType.keys()].filter(p => this.attributeToType.get(p) === typeUri);
        let allValues = paramsOfType.map(p => this.attributeToValue.get(p)).filter(v => v != null);
        //calculate value based on behavior
        let value;
        if (allValues.length > 0) {
            if (this.typeToBehavior.get(typeUri) === dymo_core_1.uris.ADDITIVE) {
                value = allValues.reduce((a, b) => a + b);
            }
            else if (this.typeToBehavior.get(typeUri) === dymo_core_1.uris.MULTIPLICATIVE) {
                value = allValues.reduce((a, b) => a * b);
            }
            else {
                value = allValues[0]; //only one value since parents not added...
            }
        }
        //update the schedulo object
        if (value != null) {
            //console.log(typeUri, value)
            this.attributeToValueAfterBehavior.set(typeUri, value);
            this.setObjectParam(typeUri, value);
        }
    }
    setObjectParam(typeUri, value) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.object) {
                const target = PAIRINGS.get(typeUri) || PAIRINGS.get(typeUri);
                //ignore onset if no previous value...
                if (typeUri !== dymo_core_1.uris.ONSET || (this.previousObject && value != null)) {
                    //merge panning into list
                    if (typeUri === dymo_core_1.uris.PAN || typeUri === dymo_core_1.uris.DISTANCE || typeUri === dymo_core_1.uris.HEIGHT) {
                        let pan = this.attributeToValueAfterBehavior.get(dymo_core_1.uris.PAN);
                        let dist = this.attributeToValueAfterBehavior.get(dymo_core_1.uris.DISTANCE);
                        let heig = this.attributeToValueAfterBehavior.get(dymo_core_1.uris.HEIGHT);
                        pan = pan ? pan : 0;
                        dist = dist ? dist : 0;
                        heig = heig ? heig : 0;
                        value = [pan, dist, heig];
                    }
                    //deal with onset specifically
                    if (typeUri === dymo_core_1.uris.ONSET) {
                        const previousOnset = yield this.previousObject.getParam(dymo_core_1.uris.ONSET);
                        if (value - previousOnset >= 0) {
                            //console.log(this.previousObject.getStartTime(), value, previousOnset, this.previousObject.getStartTime()+value-previousOnset)
                            value = value - previousOnset;
                        }
                        else {
                            value = value + this.previousObject.getDuration();
                        }
                    }
                    //console.log(this.dymoUri, typeUri, value);
                    this.object.set(target, value);
                }
            }
        });
    }
    observedValueChanged(paramUri, paramType, value) {
        this.attributeToValue.set(paramUri, value);
        this.updateObjectParam(paramType);
    }
}
exports.ScheduloScheduledObject = ScheduloScheduledObject;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-player/lib/wrapper.js
// module id = 1319
// module chunks = 3